
import React from 'react';
import { useState } from 'react';
import jsPDF from 'jspdf';
import { format } from 'date-fns';
import 'jspdf-autotable';
import ColorConverter from './HexadecimalConvertor';


const PDFGenerator = (items) => {
  const [pdfContent, setPdfContent] = useState('');


  const PDFGenerator = () => {
    const pdf = new jsPDF();
    // Prepare The Font
    const font = "Newsreader";
    const company = 'Store Team'
    // header Image
    const headerImage = "../../../image/icons/letter.jpg";
    pdf.addImage(headerImage, 'JPG', 10, 10, 190, 43);

    // prepare in here a line
    pdf.setLineWidth(0.1);
    // Line color (RGB)
    pdf.setDrawColor(200, 200, 200);
    pdf.line(10, 55, 200, 55)


    pdf.setFontSize(10);
    pdf.setFont(`${font}`, 'normal');
    pdf.text('Task Material Details', 10, 60);
    pdf.text('Invo No: ', 10, 66);
    pdf.text('PLM-Z1BX0K-114', 25, 66);
    pdf.text('Task ID: ', 10, 72);
    pdf.text('PLM-Z1BX0K-114', 25, 72);
    // pdf.text('Consumer: ', 10, 78);
    // pdf.text('Omar Ali Elmi', 27, 78);
    pdf.text(`Date On: ${format(new Date(), 'MMM dd, yyyy')}`, 166, 60);

    // pdf.text(`Date On: ${Math.floor(pdf.internal.pageSize.height/4)}`, 166, 60)


    // Description
    pdf.setFont(`${font}`, 'bold')
    pdf.text('Dear: ', 10, 90)
    pdf.text(`${company}`, 21, 90)

    pdf.setFontSize(11);
    pdf.setFont(`${font}`, 'normal');
    
    const text = `We hope this message finds you well. We kindly request the following materials listed below:`;
    
    const Text = text && text !== "" && text.trim();
    const splitTexts = pdf.splitTextToSize(Text, 185);
    const lineHeight = 5.5; 
    
    splitTexts.forEach((line, index) => {
        pdf.text(line, 10, 98 + (index * lineHeight));
    });
    


    // const description = `We have received the requested materials from Supplier Horyal Stationary on ${format(new Date('2024-09-10'), 'MMM dd, yyyy')}`;
    // const longText = description && description !== "" && description?.trim();
    // pdf.setFont(`${font}`, 'normal')
    // const splitText = pdf.splitTextToSize(longText, 185)
    // pdf.text(splitText, 10, 111);

    // Sample items data
    const itemsData = [
      {
        Name: 'Water Tanks',
        requestd: "15",
        recieved: "10",
      },
      {
        Name: 'Water Tanks',
        requestd: "15",
        recieved: "10",
      },
     
    ];



    // Set document properties
    pdf.setProperties({
      title: "Request For Quotation"
    })


    const itemDetailsRows = itemsData.map((item, index) => [
      (index + 1).toString(),
      item.Name.toString(),
      item.recieved.toString(),
      item.UniteName.toString(),
    ]);


    // Generate AutoTable for item details
    // const itemDetailsRows = itemsData?.map((item, index) => [
    //   (index + 1).toString(),
    //   item.itemName.toString(),
    //   item.requestd?.toString(),
    //   item.recieved?.toString(),
    //   item.unit?.toString(),
    //   item.status?.toString(),
    //   item.price?.toString(),
    //   item.total?.toLocaleString(),
    // ]);

    // // Add total row
    // itemDetailsRows.push([
    //   '',
    //   '',
    //   '',
    //   '',
    //   '',
    //   '',
    //   'Total:',
    //   122
    // ]);


    const itemDetailsHeaders = ['No', 'Name', 'RequestedQty', 'Unit'];
    const columnWidths = [15, 60, 79, 30];

    const headerStyles = {
        fillColor: [...ColorConverter('#e9ecef')],
        textColor: [0],
        fontFamily: `${font}`,
        fontStyle: 'bold',
    };

    pdf.setFont(`${font}`);

    pdf.autoTable({
        head: [itemDetailsHeaders],
        body: itemDetailsRows,
        startY: 105,
        headStyles: {
            fillColor: headerStyles.fillColor,
            textColor: headerStyles.textColor,
            fontStyle: headerStyles.fontStyle,
            fontSize: 10,
            font: font,
            halign: 'left',
        },
        columnStyles: {
            0: { cellWidth: columnWidths[0] },
            1: { cellWidth: columnWidths[1] },
            2: { cellWidth: columnWidths[2] },
            3: { cellWidth: columnWidths[3] },
        },
        alternateRowStyles: { fillColor: [255, 255, 255] },
        bodyStyles: {
            fontSize: 10,
            font: font,
            cellPadding: { top: 1, right: 5, bottom: 1, left: 2 },
            textColor: [0, 0, 0],
            rowPageBreak: 'avoid',
            halign: 'left',
        },
        margin: { top: 10, left: 10 },
        didDrawCell: function (data) {
            const cell = data.cell;
            if (cell.section === 'body' && data.row.index !== undefined && data.row.index !== itemDetailsRows.length - 1) {
                const lineWidth = 0.7;
                const { x, y, width, height } = cell;
                pdf.setDrawColor(...ColorConverter('#e9ecef'));
                pdf.setLineWidth(lineWidth);
                pdf.line(x, y + height, x + width, y + height);
            }
        },
    });

    // Add summary and page numbers
    const summaryYStart = pdf.internal.pageSize.getHeight() - 50;
    // pdf.setDrawColor(...ColorConverter('#099396'))
    // pdf.line(10, 255, 200, 255)
    pdf.setFont('Newsreader', 'noraml')
    pdf.text('Signatured, _________________', 13, summaryYStart + 8)
    pdf.text('Thanking You,', 13, summaryYStart + 18)
    pdf.text('Yours Faithfully,', 13, summaryYStart + 23)
    pdf.text('For ', 13, summaryYStart + 28)
    pdf.setFont('Newsreader', 'bold')
    pdf.text('The Palms Hotel', 19, summaryYStart + 28)



    const totalPages = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(10);
      pdf.setFont('Newsreader', 'normal');
      pdf.text(`Page ${i} of ${totalPages}`, pdf.internal.pageSize.width - 10, pdf.internal.pageSize.height - 8, { align: 'right' });
      pdf.setDrawColor(...ColorConverter('#adb5bd'))
      pdf.line(10, 283, 200, 283)
      pdf.setTextColor(...ColorConverter('#0000000'))
      pdf.setFont(`${font}`, "italic")
      pdf.text('Prepared By: Nuur Hassan Mohamed', 10, pdf.internal.pageSize.height - 8)
    }


    const pdfContent = pdf.output('datauristring');
    setPdfContent(pdfContent);

    //return  pdf.save('Request.pdf');
  }

  return (
    <div className="row">
      <div className="col-9 mx-3">
        {pdfContent && <embed src={pdfContent} type="application/pdf" width="100%" height="750px" />}
      </div>
      <div className="col-6">
        <button onClick={PDFGenerator}>Generate PDF</button>
      </div>
    </div>
  );
};

export default PDFGenerator;
























